import SettingsTabBase from "./SettingsTabBase.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";
export default class SettingsIntegrationsTab extends SettingsTabBase {
  static get $name() {
    return "SettingsIntegrationsTab";
  }

  static get type() {
    return "settingsintegrationstab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.integrationTab;
  }

  static get configurable() {
    return {
      title: "Integrations",
      cls: "gap-[1em] p-[1em]",
      defaults: {
        labelWidth: 150
      },
      items: {
        companyCamContainer: {
          type: "container",
          flex: "1 0 100%",
          items: {
            companyCamApiKeyField: {
              type: "textField",
              value: "",
              cls: "!flex items-start justify-start !flex-col gap-3",
              label: "Add CompanyCam API Access Token",
              labelCls: "pt-[1em] w-full block",
              flex: "1 0 78%",
              margin: 0,
              weight: 155,
              // clear errors onchange
              onInput: ({source}) => {
                source.clearError();
                source.parent.widgetMap.companyCamKeyAddedMessage.hidden = true;
                // set button to blue
                const companyCamButton = source.parent.widgetMap.companyCamButton;
                companyCamButton.color = "b-blue";
              },
            },
            companyCamButton: {
              type: "button",
              rendition: "filled",
              flex: "1 0 20%",
              text: "Save Token",
              weight: 160,
              onClick: "up.saveCompanyCamApiKey",
            },
            companyCamKeyAddedMessage: {
              html: "",
              hidden: true,
              flex: "1 0 100%",
              cls: 'pt-2 opacity-100',
              margin: 0,
            },
          }
        },
      }
    };
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    const { project } = context;

    project.extraBoardIntegrationsStore.forEach(r => {
      const widgetRef = `${r.key}Button`;
      if (widgetRef in this.widgetMap) {
        const apiKeyValue = r.value;
        const widgetText = apiKeyValue ? "Update Token" : "Save Token";
        this.widgetMap[widgetRef].text = widgetText;
        this.widgetMap[`${r.key}ApiKeyField`].value = apiKeyValue;
      }
    });
  }

  saveCompanyCamApiKey() {
    const { project } = this.context;
    const { companyCamApiKeyField, companyCamKeyAddedMessage, companyCamButton } = this.widgetMap;
    const apiKeyValue = companyCamApiKeyField.value;
    const companyCamRecord = project.extraBoardIntegrationsStore.find(r => r.key === 'companyCam');

    // if value is blank, remove the integration with companyCam
    if (apiKeyValue === '' && companyCamRecord) {
      project.extraBoardIntegrationsStore.remove(companyCamRecord);
      companyCamKeyAddedMessage.html = `<small style="opacity:0.5;">Access Token Successfully Removed.</small>`;
      companyCamKeyAddedMessage.hidden = false;
      companyCamApiKeyField.clearError();
      companyCamButton.text = "Save Token";
    }

    // if value is not blank, validate with companyCam and add/update the integration
    if (apiKeyValue !== '') {
      this.validateApiKey(apiKeyValue, 'https://api.companycam.com/v2/company').then(response => {
        // if no errors are returned, save or update the api key
        if (typeof(JSON.parse(response).errors) === 'undefined') {
          if (companyCamRecord) {
            // only make the update if the value is new to reduce api calls
            if(companyCamRecord.value !== apiKeyValue) {
              companyCamRecord.value = apiKeyValue;
              companyCamKeyAddedMessage.html = `<small style="opacity:0.5;">API access token saved successfully.</small>`;
              companyCamKeyAddedMessage.hidden = false;
            }
          } else {
            project.extraBoardIntegrationsStore.add({
              key: 'companyCam',
              value: apiKeyValue
            });
            companyCamKeyAddedMessage.html = `<small style="opacity:0.5;">API access token saved successfully.</small>`;
            companyCamKeyAddedMessage.hidden = false;
          }
          companyCamApiKeyField.clearError();
          companyCamButton.text = "Update Token";
          companyCamButton.color = "";
        } else {
          const errorMessage = 'Invalid. Please check your API access token and try again.';
          companyCamApiKeyField.setError(errorMessage);
          companyCamKeyAddedMessage.html = `<small style="color:#d32f2f;">${errorMessage}</small>`;
          companyCamKeyAddedMessage.hidden = false;
        }
    }).catch(error => {
      console.log('error', error);
    });
    }
  }

  validateApiKey = async (apiKey, url) => {
    return fetch( url , {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + apiKey
      }
    }).then(response => response.text())
      .then(result => {
        return (result);
      })
      .catch(error => {
        return ('error', error);
      });
  }

  swivuCheckGrants(user) {
    if (user.isDemoUser || user.isSandboxBoard || !user.can(GRANTS.grant_one)) {
      const { companyCamApiKeyField, companyCamButton } = this.widgetMap;
      companyCamApiKeyField.disabled =
      companyCamButton.disabled = true;
    }
  }
}

SettingsIntegrationsTab.initClass();
